import type { IWorkJourneyManagementUser } from '@src/models/interfaces/workJourneyManagement.interface';

import { formatCoverUserDisplayName } from './formatCoverUserDisplayName';

/**
 * True when the cover-drawer user row still needs an org-user profile hydrate
 * (label fell back to id / em dash because names were missing or corrupt).
 */
export const needsCoverUserProfileHydration = (user: IWorkJourneyManagementUser): boolean => {
  if (!user.id) return false;
  const label = formatCoverUserDisplayName(user);
  return label === user.id || label === '—';
};

export const mergeCoverUsersWithOrgProfiles = (
  users: IWorkJourneyManagementUser[],
  profilesById: Map<string, IWorkJourneyManagementUser>,
): IWorkJourneyManagementUser[] =>
  users.map(user => {
    const profile = profilesById.get(user.id);
    if (!profile || !needsCoverUserProfileHydration(user)) {
      return user;
    }
    return {
      ...user,
      displayName: profile.displayName,
      firstName: profile.firstName || user.firstName,
      lastName: profile.lastName || user.lastName,
      idCard: profile.idCard || user.idCard,
      email: profile.email || user.email,
    };
  });
